import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchBar2 from "../../components/SearchBar2";
import Pagination from "../../components/Pagination";
// import WarnModal from "../../components/WarnModal";
import { isNumber, isValidInput } from "../../utils/validation";
import WarnModal from "../../components/WarnModal";
import {
  useLazyVendorPaymentSummaryQuery,
  usePamentToVendorMutation,
} from "../../services/payment";
import { errorToast, successToast } from "../../helpers";
import { generateResponsiveStyle } from "../../utils/modalStyle";
import useTranslation from "../../hooks/Translation";

const ManagePayments = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const style = generateResponsiveStyle();
  const [paymentSummary] = useLazyVendorPaymentSummaryQuery();
  const [payment] = usePamentToVendorMutation();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<any>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [paymentData, setPaymentData] = useState<any>([]);
  const [amount, setAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [pendingPayment, setPendingPayment] = useState(0);

  // const totalPages = Math.ceil(filteredPayments.length / limit);

  const getPaymentSummary = async () => {
    const body = {
      start: 1,
      length: 10,
      search: "",
    };
    try {
      const response = await paymentSummary(body).unwrap();
      if (response?.status === 200) {
        setPaymentData(response?.data);
      } else {
        setPaymentData([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePayment = async (id: any) => {
    const body = {
      amount_pay: Number(amount),
      remark: remarks,
      date: new Date().toISOString(),
    };
    try {
      const response = await payment({ body, id }).unwrap();
      if (response?.status === 200) {
        getPaymentSummary();
        successToast("Payment Done Successfully");
        setModalOpen(false);
        setRemarks("");
        setAmount("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getPaymentSummary();
  }, []);

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.sideBar.managePayments}</h1>
        </div>
        <Card className="cards">
          <Box className="cards_header">
            <div className="cards_header_right">
              <SearchBar2
                value={searchTerm}
                searchTerm={searchTerm}
                onCross={() => setSearchTerm("")}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </div>

            <Box className="cards_header_right">
              {/* <Button
                className="btn btn_primary"
                onClick={() => navigate("/manage-Payments/add")}
              >
                <AddIcon />
                Add Payment
              </Button> */}
            </Box>
          </Box>

          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="payment table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell>{t.main.vendorName}</TableCell>
                  <TableCell>{t.main.totalPayments}</TableCell>
                  <TableCell>{t.main.pendingPayments}</TableCell>
                  <TableCell>{t.main.amountPaidToVendor}</TableCell>
                  <TableCell>{t.main.makePayment}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentData?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      {t.error.noData}
                    </TableCell>
                  </TableRow>
                ) : (
                  paymentData?.map((payment: any, index: number) => (
                    <TableRow key={payment?.vendor_id}>
                      <TableCell align="center">
                        {(page - 1) * limit + index + 1}
                      </TableCell>
                      <TableCell>{payment?.vendor_name || "-"}</TableCell>
                      <TableCell>
                        AED {payment?.total_payments || "0"}
                      </TableCell>
                      <TableCell>
                        AED {payment?.pending_payments || "0"}
                      </TableCell>
                      <TableCell>
                        AED {payment?.amount_paid_to_vendor || "0"}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={t.main.makePayment}
                          variant="outlined"
                          onClick={() => {
                            setSelectedId(payment?.vendor_id);
                            setModalOpen(true);
                            setPendingPayment(payment?.pending_payments);
                          }}
                          sx={{ borderColor: "#2B604C" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

        <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="modal_title">
              <Typography id="modal-modal-title" component="h2">
                Make Payment
              </Typography>
              <CloseIcon
                className="cross_icn_logout"
                onClick={() => setModalOpen(false)}
              />
            </div>

            <div className="modal_body">
              <div className="control_group">
                <TextField
                  className="text_field"
                  hiddenLabel
                  placeholder={t.main.amount}
                  fullWidth
                  type="text"
                  variant="outlined"
                  inputProps={{ maxLength: 10 }}
                  value={amount}
                  onChange={(val) => {
                    const value = val.target.value;
                    if (value === " " || value === ".") return;

                    // Regex to allow only numbers with up to two decimal places
                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                      setAmount(value);
                    }
                  }}
                />
              </div>
              <div className="control_group" style={{ marginTop: 20 }}>
                <TextField
                  className="text_field"
                  hiddenLabel
                  placeholder={t.main.remarks}
                  fullWidth
                  type="text"
                  inputProps={{ maxLength: 40 }}
                  variant="outlined"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>

              <div className="form_btn">
                <Button
                  disabled={amount === "" || remarks === ""}
                  className="btn btn_primary"
                  onClick={() => {
                    if (Number(pendingPayment) < Number(amount)) {
                      errorToast("Amount is higher than pending payment");
                      return;
                    } else {
                      handlePayment(selectedId);
                    }
                  }}
                >
                  {t.main.pay}
                </Button>
                <Button
                  className="btn btn_secondary"
                  onClick={() => setModalOpen(false)}
                >
                  {t.main.cancel}
                </Button>
              </div>
            </div>
          </Box>
        </Modal>

        {/* {displayedPayments.length > 0 && (
          <Pagination
            setPage={setPage}
            module={displayedPayments}
            page={page}
            onPageChange={setPage}
            totalPages={totalPages}
            limit={limit}
            setLimit={setLimit}
          />
        )} */}
      </div>

      {/* <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={handleDeletePayment}
        name="Payment"
      /> */}
    </div>
  );
};

export default ManagePayments;
